import { styled } from 'styled-components';

const Background = styled.img<{ $objectFit?: string }>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.$objectFit ?? 'fill'};
`;

export default Background;
